import { render, staticRenderFns } from "./OfficeToolbar.vue?vue&type=template&id=7555af7c&scoped=true&"
import script from "./OfficeToolbar.vue?vue&type=script&lang=ts&"
export * from "./OfficeToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeToolbar.vue?vue&type=style&index=0&id=7555af7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7555af7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
